export const isAdmin = (user) => user?.role === "admin";
export const isManager = (user) => user?.role === "manager";
export const isDemo = (user) => user?.role === "demo";
export const canMeasure = (user) => ["user", "manager", "admin"].includes(user?.role);
export const canManageFiltering = (user) => ["manager", "admin"].includes(user?.role);
export const canViewRawData = canManageFiltering;
export const canResetDevice = canManageFiltering;
export const canAdminister = isAdmin;

export const roleLabel = (role, t) => ({
  user: t("Gebruiker", "User"),
  manager: t("Manager", "Manager"),
  admin: t("Beheerder", "Administrator"),
  demo: t("Live demo", "Live demo"),
}[role] || role || "—");

// Broader read visibility does not authorize cross-organization operations.
export const canOperateDevice = (user, device) => !user?.preview_read_only && (
  user?.role === "admin" || (["user", "manager"].includes(user?.role) && !!user?.organization_id && user.organization_id === device?.organization_id)
);
